const { createSlice } = require('@reduxjs/toolkit');

const initialState = {
  callsData: null,
  landersData: null,
};

const aiSlice = createSlice({
  name: 'aiHub',
  initialState,
  reducers: {
    setCallsData: (state, action) => {
      state.callsData = action.payload; 
    },
    setLandersData: (state, action) => {
      state.landersData = action.payload; 
    },
  },
});

export const {
  setCallsData,
  setLandersData
} = aiSlice.actions;

export const selectCallsData = (state) => state.aiHub.callsData;
export const selectLandersData = (state) => state.aiHub.landersData;

export default aiSlice.reducer;
